import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { IssuesTable } from "#app/components/issues/issues-table";
import type { IssueScope } from "#app/lib/filters/issue-scope";

/** `/team/$teamId/list` — the team's Projects across its workflows: assigned
 *  to it (the Teams column says so) and, on the view's "Show shared
 *  Projects" switch, shared with it. The view's own config decides. */
function TeamListRoute() {
  const { teamId } = Route.useParams();
  const scope = useMemo<IssueScope>(
    () => ({ kind: "team", teamId }),
    [teamId],
  );
  return <IssuesTable scope={scope} />;
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/list")({
  component: TeamListRoute,
});
